import * as React from "react";
import Spinner from "components/common/Spinner";
import useOwnerAssignee from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles";
import AssigneeCell from "../../common/AssigneeCell";
const LoadOwner = ({ owner }) => {
  const { data: assignee, isInitialLoading } = useOwnerAssignee(owner);
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (!assignee) {
    return /* @__PURE__ */ React.createElement("i", null, "none");
  }
  return /* @__PURE__ */ React.createElement(AssigneeCell, { assignee });
};
const OwnerCell = ({ owner }) => {
  if (owner === null || owner === "null") {
    return /* @__PURE__ */ React.createElement("i", null, "none");
  }
  return LoadOwner({ owner });
};
export default OwnerCell;
